import React from 'react';
import { formatPartialDate, formatReviewDate } from '../helpers';

export function TextWidget({ value }) {
  return (
    <span className="dd-privacy-hidden" data-dd-action-name="data value">
      {value}
    </span>
  );
}

export function DateWidget({ value, options, formContext }) {
  const display = formContext?.renderOptions?.spellOutDates
    ? formatPartialDate(
        value,
        options.monthYear
          ? { year: 'numeric', month: 'long' }
          : { year: 'numeric', month: 'long', day: 'numeric' },
      )
    : formatReviewDate(value, options.monthYear);
  return (
    <span className="dd-privacy-hidden" data-dd-action-name="data value">
      {display}
    </span>
  );
}

export const EmailWidget = TextWidget;
export const TextareaWidget = TextWidget;

export function SelectWidget({ options, value }) {
  const { enumOptions, labels = {} } = options;
  const selected = enumOptions.find(opt => opt.value === value);
  if (selected) {
    const label =
      typeof labels[value] === 'object' ? labels[value]?.label : labels[value];
    return (
      <span className="dd-privacy-hidden" data-dd-action-name="data value">
        {label || selected.label}
      </span>
    );
  }

  return null;
}

export const RadioWidget = SelectWidget;

export const yesNo = ({ value, options = {} }) => {
  const { yesNoReverse = false, labels = {} } = options;
  const yesValue = !yesNoReverse;
  const noValue = !yesValue;

  let displayValue;
  if (value === yesValue) {
    displayValue = labels.Y || 'Yes';
  } else if (value === noValue) {
    displayValue = labels.N || 'No';
  }

  return (
    <span className="dd-privacy-hidden" data-dd-action-name="data value">
      {displayValue}
    </span>
  );
};

export const CheckboxWidget = ({ value, schema = {} }) => (
  <span className="dd-privacy-hidden" data-dd-action-name="data value">
    {value === true
      ? schema.enumNames?.[0] || 'Selected'
      : schema.enumNames?.[1] || ''}
  </span>
);
